import React, {
  useState,
  useEffect,
} from 'react';
import { connect } from 'react-redux';
import {
  Menu,
  // Card,
  // Row,
  // Col,
} from 'antd';
import {
  Route,
  Switch,
  useLocation,
} from 'react-router-dom';

import { transferSettingsActions } from 'store/actions';
import { SpTab } from 'components/DesignKit';
// import getCountryPhoneCode from 'utils/getCountryPhoneCode';

// import Loading from 'components/Loading';
// import { SpButton, SpH5, SpText } from 'components/DesignKit';

import RBAC from 'components/rbac';
import { ROLES } from 'appconstants';
import TransferSettingsComp from './Settings';
import TransferApprovals from './Approvals';

type Props = {
  fetchTransferSetting: Function,
  updateTransferSetting: Function,
  addTransferSetting: Function,
  transferSettings: Object,
  loading: boolean,
  test: boolean,
  selectedAccount: Object,
  validator: boolean,
};

const TransferSettings = (props: Props) => {
  const location = useLocation();

  const [current, setCurrent] = useState('/settingtransfers');

  useEffect(() => {
    if (location) {
      setCurrent(location.pathname);
    }
  }, [location]);

  return (
    <div>
      <RBAC
        permit={[
          ROLES.OWNER,
          ROLES.ADMINISTRATOR,
          ROLES.SUPERUSER,
          ROLES.DEVELOPER,
          ROLES.OPERATIONS,
          ROLES.OFFICEMANAGER,
          ROLES.TRANSFERAPPROVER,
          ROLES.TRANSFERRECON,
          ROLES.TRANSFERSUPPORT,
        ]}
        fallback={
          <div>No Permission</div>
        }
      >
        <Menu
          onClick={e => setCurrent(e.key)}
          selectedKeys={[current]}
          mode="horizontal"
          style={{
            fontSize: '20px',
            marginBottom: '0px',
          }}
        >
          <Menu.Item key="/settingtransfers">
            <SpTab
              to="/settingtransfers"
              selected={current === '/settingtransfers'}
            >
              Settings
            </SpTab>
          </Menu.Item>
          <Menu.Item key="/settingtransfers/approvals" disabled={!props.transferSettings?.enableApprovals}>
            <RBAC
              permit={[
                ROLES.OWNER,
                ROLES.SUPERUSER,
                ROLES.INTERNALSUPPORT,
                ROLES.ONBOARDING,
                ROLES.TRANSFERSUPPORT,
                ROLES.TRANSFERAPPROVER,
              ]}
            >
              <SpTab
                to="/settingtransfers/approvals"
                selected={current === '/settingtransfers/approvals'}
              >
                Approvals
              </SpTab>
            </RBAC>
          </Menu.Item>
        </Menu>
        <Switch>
          <Route exact path="/settingtransfers/approvals" component={TransferApprovals} />
          <Route exact path="/settingtransfers" render={() => <TransferSettingsComp {...props} />} />
        </Switch>
      </RBAC>
    </div>
  );
};

const mapStateToProps = state => ({
  selectedAccount: state.account.selectedAccount,
  transferSettings: state.transferSettings.content,
  loading: state.loading.loading,
  test: state.account.test,
  isSuperUser: state.user.superUser,
  validator: state.loading.validator,
});

const mapDispatchToProps = dispatch => ({
  fetchTransferSetting: gid => dispatch(transferSettingsActions.fetchTransferSetting({
    payload: gid,
  })),
  addTransferSetting: payload => dispatch(transferSettingsActions.addTransferSetting({
    payload,
  })),
  updateTransferSetting: params => dispatch(transferSettingsActions.updateTransferSetting({
    payload: params,
  })),
});

// $FlowFixMe
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransferSettings);
